export default {
  MusicCategories: [
    {
      category: 'Thematic',
      tracks: [
        {
          // id: 1,
          // trackName: 'Desert Walk',
          // fileName: 'Desert Walk.mp3',
          // category: 'Thematic',
        },
        {
          id: 2,
          trackName: 'Technology Vs Itself',
          fileName: 'Technology Vs Itself.mp3',
          category: 'Thematic'
        },
        {
          id: 3,
          trackName: 'To Patagonia',
          fileName: 'To Patagonia.mp3',
          category: 'Thematic',
        },
        {
          id: 4,
          trackName: 'Bowed',
          fileName: 'Bowed.mp3',
          category: 'Thematic'
        },
        {
          id: 5,
          trackName: 'DX Pizz 01',
          fileName: 'DX Pizz-1.mp3',
          category: 'Thematic'
        },
        {
          id: 6,
          trackName: 'One Lead Thing To Another',
          fileName: 'One Lead Thing To Another.mp3',
          category: 'Thematic'
        },
        {
          id: 7,
          trackName: 'Thud',
          fileName: 'Thud.mp3',
          category: 'Thematic'
        },
        {
          id: 8,
          trackName: 'A Mirthful Death',
          fileName: 'A Mirthful Death.mp3',
          category: 'Thematic'
        },
        {
          id: 9,
          trackName: 'MT Waltz',
          fileName: 'MT Waltz.mp3',
          category: 'Thematic'
        },
        {
          id: 10,
          trackName: 'Bloom',
          fileName: 'Bloom.mp3',
          category: 'Thematic',
        },
        {
          id: 11,
          trackName: 'Little Ones',
          fileName: 'Little Ones.mp3',
          category: 'Thematic'
        },
         {
          id: 12,
          trackName: '389 Sooth',
          fileName: '389 Sooth.mp3',
          category: 'Thematic'
        },
        
        
        
        
        
        
        
        
       
      ],
    },
    {
      category: 'Atmospheric',
      tracks: [
        {
          id: 1,
          trackName: 'Red Chords',
          fileName: 'Red Chords.mp3',
          category: 'Atmospheric'
        },
        {
          id: 2,
          trackName: 'Zombie 01',
          fileName: 'Zombie 01.mp3',
          category: 'Atmospheric'
        },
        {
          id: 3,
          trackName: '(Caught)',
          fileName: '(Caught).mp3',
          category: 'Atmospheric'
        },
        {
          id: 4,
          trackName: 'Escape From The North',
          fileName: 'Escape From The North.mp3',
          category: 'Atmospheric'
        },
        {
          id: 5,
          trackName: 'DS-01',
          fileName: 'DS-01.mp3',
          category: 'Atmospheric',
        },
        {
          id: 6,
          trackName: 'A Restful Piece',
          fileName: 'A Restful Piece.mp3',
          category: 'Atmospheric'
        },
         {
          id: 7,
          trackName: 'Cows Afterlife',
          fileName: 'Cows Afterlife.mp3',
          category: 'Atmospheric'
        },
        {
          id: 8,
          trackName: '1-772',
          fileName: '1-772.mp3',
          category: 'Atmospheric'
        },
        {
          id: 9,
          trackName: 'Cntrl Alt Delete',
          fileName: 'Cntrol Alt Delete.mp3',
          category: 'Atmospheric'
        },
        {
          id: 10,
          trackName: 'A Hampsfell Presence',
          fileName: 'A Hampsfell Presence.mp3',
          category: 'Atmospheric'
        },
        {
          id: 11,
          trackName: 'Odyssey',
          fileName: 'Odyssey.mp3',
          category: 'Atmospheric'
        },
        {
          id: 1,
          trackName: 'Sirralda',
          fileName: 'Sirralda.mp3',
          category: 'Atmospheric',
        },
        
        
        
        
        
       
        
        
        
        
      ]
    },
    {
      category: 'Ambient',
      tracks: [
        {
          id: 1,
          trackName: '(a) Being Returning Home (Part i)',
          fileName: '(a) Being Returning Home (Part i).mp3',
          category: 'Ambient'
        },
        {
          id: 2,
          trackName: '(a) Being Returning Home (Part iii)',
          fileName: '(a) Being Returning Home (Part iii).mp3',
          category: 'Ambient'
        },
        {
          id: 3,
          trackName: 'Possessed',
          fileName: 'Possessed.mp3',
          category: 'Ambient'
        },
        {
          id: 4,
          trackName: 'Shall Nothingness Prevail',
          fileName: 'Shall Nothingness Prevail.mp3',
          category: 'Ambient'
        },
        {
          id: 5,
          trackName: 'Drain Circle',
          fileName: 'Drain Circle.mp3',
          category: 'Ambient'
        },
        {
          id: 6,
          trackName: 'St Giles',
          fileName: 'St Giles.mp3',
          category: 'Ambient'
        },
        {
          id: 7,
          trackName: 'At Least There Are Still Trees... (1)',
          fileName: 'At Least There Are Still Trees... (1).mp3',
          category: 'Ambient'
        },
        {
          id: 8,
          trackName: 'At Least There Are Still Trees... (2)',
          fileName: 'At Least There Are Still Trees... (2).mp3',
          category: 'Ambient'
        },
        {
          id: 9,
          trackName: 'At Least There Are Still Trees... (3)',
          fileName: 'At Least There Are Still Trees... (3).mp3',
          category: 'Ambient'
        },
        {
          id: 10,
          trackName: 'Meditation 02',
          fileName: 'Meditation 02.mp3',
          category: 'Ambient'
        },
        {
          id: 11,
          trackName: 'Out Of The Doldrums',
          fileName: 'Out Of The Doldrums.mp3',
          category: 'Ambient'
        },
        {
          id: 12,
          trackName: 'Forbidden',
          fileName: 'Forbidden.mp3',
          category: 'Ambient'
        },
        {
          id: 13,
          trackName: 'Lorelei',
          fileName: 'Lorelei.mp3',
          category: 'Ambient'
        },
        
        

      ]
    },
    {
      category: 'Songs',
      tracks: [
        {
          id: 1,
          trackName: 'BLooD',
          fileName: 'BLooD.mp3',
          category: 'Songs'
        },
         {
          id: 2,
          trackName: '607 Boards (Version 2)',
          fileName: '607 Boards (Version 2).mp3',
          category: 'Songs'
        },
         {
          id: 3,
          trackName: 'Jacques Lacan',
          fileName: 'Jacques Lacan.mp3',
          category: 'Songs'
        },
        {
          id: 4,
          trackName: 'The Mask Of Newo (Version 2)',
          fileName: 'The Mask Of Newo (Version 2).mp3',
          category: 'Songs'
        },
        {
          id: 5,
          trackName: 'No Tomorrow',
          fileName: 'No Tomorrow.mp3',
          category: 'Songs'
        },
        {
          id: 7,
          trackName: 'Our Fire Of Love (Other Chat Version)',
          fileName: 'Our Fire Of Love (Other Chat Version).mp3',
          category: 'Songs'
        },
        
        {
          id: 8,
          trackName: 'A Field In Cornwall',
          fileName: 'A Field In Cornwall.mp3',
          category: 'Songs',
        },
        
      ]
    },
    {
      category: 'Beats',
      tracks: [
         {
          id: 1,
          trackName: 'Fairness',
          fileName: 'Fairness.mp3',
          category: 'Beats'
        },
         {
          id: 2,
          trackName: 'Soft Clone',
          fileName: 'Soft Clone.mp3',
          category: 'Beats'
        },
        {
          id: 3,
          trackName: 'Bassolin',
          fileName: 'Bassolin.mp3',
          category: 'Beats'
        },
         {
          id: 4,
          trackName: 'Hollowed Out',
          fileName: 'Hollowed Out.mp3',
          category: 'Beats'
        },
        
         
        {
          id:5,
          trackName: 'Banjo',
          fileName: 'Banjo.mp3',
          category: 'Beats'
        },
        
        {
          id: 6,
          trackName: 'Willow',
          fileName: 'Willow.mp3',
          category: 'Beats'
        },
         {
          id: 7,
          trackName: 'Running Wild',
          fileName: 'Running Wild.mp3',
          category: 'Beats'
        },
         {
          id: 8,
          trackName: 'Sweep',
          fileName: 'Sweep.mp3',
          category: 'Beats'
        },
        
        
        {
          id: 9,
          trackName: 'Sent',
          fileName: 'Sent.mp3',
          category: 'Beats'
        },
        {
          id: 10,
          trackName: 'The Emerson Time Machine',
          fileName: 'The Emerson Time Machine.mp3',
          category: 'Beats'
        },
       
       
       
       
        {
          id: 10,
          trackName: 'When You Are Gone',
          fileName: 'When You Are Gone.mp3',
          category: 'Beats'
        },

      ]
    },
    {
      category: 'Noisey',
      tracks: [
        {
          id: 1,
          trackName: 'Loveless',
          fileName: 'Loveless.mp3',
          category: 'Noisey'
        },
        {
          id: 2,
          trackName: 'Unfed',
          fileName: 'Unfed.mp3',
          category: 'Noisey'
        },
         {
          id: 3,
          trackName: '(a) Being Returning Home (Part v)',
          fileName: '(a) Being Returning Home (Part v).mp3',
          category: 'Noisey'
        },
         {
          id: 4,
          trackName: 'Night Noise 22.1.13',
          fileName: 'Night Noise 22.1.13.mp3',
          category: 'Noisey'
        },
         {
          id: 5,
          trackName: 'Feed',
          fileName: 'Feed.mp3',
          category: 'Noisey'
        },
         {
          id: 6,
          trackName: 'Expeller',
          fileName: 'Expeller.mp3',
          category: 'Noisey'
        },
        

      ]
    }
  ],
};
